import React, { useEffect, useState } from 'react'
import delet from '../../../Assets/Images/delete.svg';
import edit from '../../../Assets/Images/edit.svg';
import Popup from 'reactjs-popup';
import Pagination from '../../Pagination/Pagination';
import { Link, useParams } from 'react-router-dom';
import { useUsers } from '../../../Context/UsersContext';
import DeletModal from '../../DeleteModel/DeletModal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay';

function AllUsersTable() {
    const { getUsers, isUsers, deleteUser } = useUsers();
    const { lang } = useParams();

    useEffect(() => {
        getUsers(lang);
    }, []);

    const handleDeleteUser = async (id) => {
        try {
            await deleteUser(id, lang);
            toast.success("User deleted successfully!");
        } catch (error) {
            toast.error("Error deleting user!");
            console.error("Error deleting user:", error);
        }
    };

    return (
        <div className='bg-[#fff] rounded-2xl p-3'>
            <ToastContainer autoClose={4000} pauseOnFocusLoss={false} pauseOnHover={false} />
            {!isUsers && <LoadingOverlay />} {/* Display loading overlay */}
            <table className='w-full border-collapse mb-6'>
                <thead>
                    <tr className='p-2'>
                        <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '10%' }}>SN</th>
                        <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '25%' }}>Name</th>
                        <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '25%' }}>email</th>
                        <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '25%' }}>Status</th>
                        <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '25%' }}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {isUsers?.data?.map((users, index) => (
                        <tr key={index}>
                            <td className='p-5 text-start' style={{ width: '10%' }}>{String(index + 1).padStart(2, '0') + "."}</td>
                            <td className='p-5 text-start' style={{ width: '25%' }}>{users.name}</td>
                            <td className='p-5 text-start' style={{ width: '25%' }}>{users.email}</td>
                            {/* <td className='p-5 text-start' style={{ width: '25%' }}>{users.category?.name}</td> */}
                            <td className='p-5 text-start' style={{ width: '25%' }}>
                                <div className={users.status == 1 ?
                                    'bg-[#0966AE] text-[#fff] p-2 w-[75px] rounded-md border text-center' :
                                    'bg-[#ffc107] p-2 w-[75px] rounded-md border text-center'}>
                                    {users.status == 1 ? "Active" : "Inactive"}
                                </div></td>
                            <td className='p-5 text-center' style={{ width: '25%' }}>
                                <div className='flex gap-2 items-center'>
                                    <Link to={`/Users/EditUser/${users.id}`}>
                                        <div className='bg-[#148342] p-2 w-[40px] cursor-pointer rounded-md border'>
                                            <img src={edit} alt="" />
                                        </div>
                                    </Link>
                                    <Popup
                                        trigger={
                                            <div className='bg-[#AF1F24] p-2 w-[40px] cursor-pointer rounded-md border'>
                                                <img src={delet} alt="" />
                                            </div>
                                        }
                                        modal
                                        nested
                                    >
                                        {(close) => (
                                            <div className="modal">
                                                <DeletModal close={close} id={users.id} onDelete={() => handleDeleteUser(users.id)} />
                                            </div>
                                        )}
                                    </Popup>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default AllUsersTable